export default function useCrossDomainRedirect() {
  const crossDomainRedirect = async () => {
    // Construct redirect URL
    const redirectURL = `${
      import.meta.env.VITE_REGISTRATION_URL
    }/dashboard-redirect`;

    // log user out from dashboard
    sessionStorage.clear();

    // Redirect to the constructed URL
    window.location.assign(redirectURL);
  };

  return { crossDomainRedirect };
}
